<template>
	<div>
		<div :class="{ 'form-disabled': isUploadLocked }">
			<div class="secsub-left-quescontainer">
				<div class="sec-addquescontainer">
					<div class="d-flex">
						<div style="width: 40%" class="sec-addques-headtxt">
							Communication Test
						</div>
						<div
							style="width: 20%"
							class="topDiv relativeclass ckeditor ques-tag-form-control w-40"
						>
							<b-form-tags
								v-model="questions.questionTags"
								no-outer-focus
								separator=" "
								remove-on-delete
								ref="questionTagref"
							>
								<template
									v-slot="{
										tags,
										inputAttrs,
										inputHandlers,
										tagVariant,
										removeTag,
									}"
								>
									<b-input-group class="cust-group-input" id="addcontainer-tag">
										<div class="d-flex no-wrap">
											<div
												class="d-inline-block cust-btn-select"
												style="font-size: 1.5rem"
											>
												<b-form-tag
													v-for="tag in tags"
													@remove="removeTag(tag)"
													:key="tag"
													:title="tag"
													:variant="tagVariant"
													class="mr-1 ml-2"
													>{{ tag }}</b-form-tag
												>
											</div>
											<b-form-input
												id="input-tag"
												v-bind="inputAttrs"
												v-on="inputHandlers"
												@keyup="hashtag()"
												placeholder="Enter Question tag"
												class="form-control min-width mr-4 ml-2"
											></b-form-input>
										</div>
									</b-input-group>
								</template>
							</b-form-tags>
						</div>

						<div class="relativeclass ml-2" ref="showdiffoptions">
							<div
								v-if="showdiffoptions"
								class="diff-dropdown d-flex"
								ref="showdiffoptions1"
								v-closable="{
									exclude: ['showdiffoptions1', 'showdiffoptions'],
									handler: 'hidediffoptions',
								}"
							>
								<b-form-group class="sec-mcq-datacard">
									<b-form-radio-group
										class="text-align-center new-difficulty-level-class"
										id="btn-radios-3"
										:options="options"
										value-field="value"
										text-field="text"
										name="radio-btn-stacked"
										@change="showdiffoptions = !showdiffoptions"
										buttons
										stacked
										v-model.trim="$v.questions.difficultyLevel.$model"
									></b-form-radio-group>
								</b-form-group>
							</div>
							<div
								class="sec-addquesbox-rightside"
								@click="showdiffoptions = !showdiffoptions"
							>
								<b-form-input
									style="background: transparent"
									class="pointer"
									readonly
									:class="{
										error: $v.questions.difficultyLevel.$error,
									}"
								>
								</b-form-input>
								<div class="placeholder">
									Difficulty Level {{ questions.difficultyLevel
									}}<span v-if="questions.difficultyLevel == ''">*</span>
								</div>
								<div
									style="position: absolute; top: 5px; right: 25px"
									v-if="
										$v.questions.difficultyLevel.$dirty &&
											!$v.questions.difficultyLevel.required
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div class="diff-downarrow">
									<img
										v-if="!showdiffoptions"
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-2 pointer"
									/>
									<img
										v-else
										class="mr-2 pointer"
										src="../../assets/uparrow.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
						<div style="width: 20%" class="relativeclass ml-2">
							<b-form-input
								v-model.trim="$v.questions.marks.$model"
								:class="{
									error: $v.questions.marks.$error,
								}"
								@keypress="validateMarks($event)"
								disabled
							>
							</b-form-input>
							<div
								class="placeholder"
								v-if="questions.marks == null || !$v.questions.marks.required"
							>
								Marks <span>*</span>
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="$v.questions.marks.$dirty && !$v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									!$v.questions.marks.between && $v.questions.marks.required
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should be between (0.5, 100)',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="!$v.questions.marks.alpha && $v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Accepts only 2 digit after decimal point',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>
					<div class="mt-2">
						<div class="topDiv mt-3 relativeclass">
							<div
								:class="
									dirtyCommuQuestion ||
									(!$v.questions.question.maxLength && !dirtyCommuQuestion)
										? 'error'
										: ''
								"
							>
								<label class="addquesboxfieldsetStyle" style="z-index: 4">
									Question &nbsp;<span class="asterik">*</span></label
								>
								<QuillEditor
									:addquesProp="addques"
									:value="$v.questions.question.$model"
									@validationVal="validateText"
									@questionText="updateQuestionContent"
									@addquesBack="changedaddQues"
								>
								</QuillEditor>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="dirtyCommuQuestion && $v.questions.question.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Required',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="!$v.questions.question.maxLength && !dirtyCommuQuestion"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 10000 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>

							<div class="media-box mt-2 align-items-center">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center">
										<div class="media-text ml-3">Add Media</div>
										<div class="ml-2">
											<img src="../../assets/vertical-line.svg" alt="" />
										</div>
										<div class="d-flex align-items-center ml-2 mt-1">
											<div class="ml-2">
												<label
													for="file-upload"
													class="pointer"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Audio supported formats are: wav, mp3"
												>
													<img src="../../assets/headphone.svg" alt="" />
												</label>
												<input
													id="file-upload"
													type="file"
													accept="audio/*"
													@change="previewFile"
												/>
											</div>
											<div class="ml-3">
												<label
													for="file-upload-video"
													class="pointer"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Video supported formats is: mp4"
												>
													<img src="../../assets/videocam.svg" alt="" />
												</label>
												<input
													id="file-upload-video"
													type="file"
													accept="video/*"
													@change="previewFile"
												/>
											</div>
											<div class="ml-3">
												<label
													for="file-upload-image"
													class="pointer"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Image supported formats are: jpg, jpeg, png"
												>
													<img src="../../assets/image-capture.svg" alt="" />
												</label>
												<input
													id="file-upload-image"
													type="file"
													accept="image/*"
													@change="previewFile"
												/>
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center"
										v-if="questions.isFailed"
									>
										<img src="../../assets/Vector.svg" alt="" class="mr-2" />
										<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
									</div>
								</div>
							</div>
							<div
								style="position: absolute; top: 10px; right: 20px"
								v-if="dirtyCommuQuestion && !$v.questions.question.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
						<!-- below div comes if image exists -->
						<template v-if="checkMedia">
							<div
								v-if="isImage(questions.questionMediaType)"
								class="mt-2 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<div class="dbmcqcardimage">
										<img
											:src="questions.questionMedia"
											alt=""
											class="w-100 h-100"
										/>
									</div>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>

							<div
								v-if="isAudio(questions.questionMediaType)"
								class="d-flex mt-2"
							>
								<div class="d-flex align-items-center mr-5">
									<img src="../../assets/audio.svg" alt="" />
									<span class="ml-2"> Audio</span>
								</div>
								<div class="d-flex align-items-center relativeclass">
									<Media
										:kind="'audio'"
										:isMuted="false"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio"
										:src="questions.questionMedia"
									></Media>
									<div class="mcq-audioxmark pointer" @click="removeMedia()">
										<img src="../../assets/xmark.svg" alt="" />
									</div>
								</div>
							</div>
							<div
								v-if="isVideo(questions.questionMediaType)"
								class="mt-3 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="questions.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="dbmcqcardimage"
									></Media>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</template>
					</div>
					<b-row v-if="showVideoUploading">
						<b-col class="ab-uploaded-card w-100 mt-3">
							<b-card no-body class="d-flex w-100">
								<section class="d-flex align-items-center pt-1">
									<div
										class="ab-uploaded-file-heading d-flex align-items-center w-75"
									>
										{{ videoData.name }}
									</div>

									<div
										class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
									>
										<b-spinner v-if="showSpinner" label="Spinning"></b-spinner>
										<span>{{ formatSize(videoData.size) }}</span>
										<!-- <span class="ml-2"> 2 sec Left</span> -->
									</div>
									<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
								</section>
								<section class="mt-2">
									<b-progress height="4px" :value="progress"></b-progress>
								</section>
							</b-card>
						</b-col>
					</b-row>
				</div>
				<div
					class="sec-addquescheckboxcontainer m-3 d-flex justify-content-end p-1"
				>
					<div class="d-flex pointer relativeclass">
						<div class="sec-addcheckboxtext mr-3" ref="showdatacard1">
							<span
								@click="
									type == 'autolong' ? addautomcqquestion() : addquestion()
								"
								>Add</span
							>
						</div>
						<div @click="clearData()" class="sec-canceltext-active">Cancel</div>
						<div
							v-if="showdatacard"
							ref="showdatacard"
							v-closable="{
								exclude: ['showdatacard', 'showdatacard1'],
								handler: 'hidedatacard',
							}"
						>
							<div class="sec-adddata-card d-flex align-items-center">
								<b-form-group class="sec-mcq-datacard">
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										name="flavour-4a"
									>
										Add to Questionbank
									</b-form-checkbox>
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										name="flavour-4a"
									>
										Add to public
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="attachdocs"
			v-model="uploadModal"
			centered
			hide-footer
			hide-header
			@show="resetModal"
			@hidden="resetModal"
		>
			<div @click="closeattachdocsmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="relativeclass sec-attachdocs">
				<div class="dot-main">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
							<div>
								<label for="file-upload" class="custom-file-upload pointer">
									<div class="d-flex flex-column align-items-center">
										<img
											src="../../assets/icons/Qpbuilder/uploadicon.svg"
											alt=""
										/>
										Click to browse or drag <br />and drop your files
									</div>
								</label>
								<input id="file-upload" type="file" @change="previewFile" />
							</div>
							<div v-if="questions.isFailed == true">
								<p style="color: red">Uploaded failed</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import QuillEditor from "./quillEditor.vue"; //Quill editor from component
import Media from "@dongido/vue-viaudio";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";

import {
	required,
	maxLength,
	between,
	helpers,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import toast from "../../views/mixin/toast";
import mediaUploadMixin from "@/views/mixin/mediaUploadMixin";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";
import { addCommunicationTest } from "../../utils/apiFunctions";
export default {
	mixins: [toast, mediaUploadMixin, socketUploadMixin],
	props: {
		type: String,
		autosectionID: String,
	},
	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
			questionAdded: "getQuestionAdded",
		}),
		...mapGetters("autotestVUEX", {
			autoselectedSection: "getSelectedSection",
			topicID: "getAutoTopicID",
		}),
	},
	watch: {
		selectedSection(newValue, oldValue) {
			if (newValue != oldValue) {
				this.questions.questionMediaType = "";
				this.questions.questionMedia = "";
			}
		},
	},
	data() {
		return {
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			addques: false,
			dirtyCommuQuestion: false,
			checkMedia: false,
			uploadModal: false,
			showdiffoptions: false,
			showdatacard: false,
			options: [
				{ value: "1", text: "Difficulty Level 1" },
				{ value: "2", text: "Difficulty Level 2" },
				{ value: "3", text: "Difficulty Level 3" },
				{ value: "4", text: "Difficulty Level 4" },
				{ value: "5", text: "Difficulty Level 5" },
			],

			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"],
			},
			questions: {
				autoCorrection: false,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: 10,
				questionType: "COMU",
				topic: "",
				questionMedia: "",
				difficultyLevel: "",
				question: "",
				fileMeta: null,
				questionFile: null,
				questionTags: [],
			},
		};
	},
	components: {
		QuillEditor, //From quill component
		Media,
	},
	validations: {
		questions: {
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),
				between: between(0.5, 100),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
		},
	},
	created() {
		if (this.questions.file && this.questions.questionMedia) {
			this.checkMedia = true;
		}
		if (!this.questions.marks) {
			this.questions.marks = 10;
		}
	},
	methods: {
		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		validateMarks(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		validateText(val) {
			this.dirtyCommuQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.questions.question = newContent;
		},
		changedaddQues(newval) {
			this.addques = newval;
		},

		//For removing Space From Top and bottom of last text of Quill Editor
		getDesiredContent() {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = this.questions.question;
			const pTags = tempDiv.querySelectorAll("p");
			let endIndex = pTags.length;
			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}
			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});
			this.questions.question = tempDiv.innerHTML;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		isImage,
		isVideo,
		isAudio,
		hidedatacard() {
			this.showdatacard = false;
		},
		hidediffoptions() {
			this.showdatacard = false;
			this.showdiffoptions = false;
		},
		async previewFile(event) {
			const file = event.target.files[0];
			if (!file) return;
			this.videoData = {
				name: file.name,
				size: file.size,
			};
			await this.handleMediaUpload(event, this.questions);
			this.checkMedia = !this.questions.isFailed;
		},

		resetModal() {
			this.questions.isFailed = false;
		},
		hashtag() {
			let str = document.getElementById("input-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("input-tag").value = tagged;
		},

		async addquestion() {
			this.showSpinner = true;
			this.validateQuestionmcq();

			if (this.$v.$invalid || this.dirtyCommuQuestion) {
				this.errorToast("Please enter all the details");
				return;
			}

			try {
				let form = new FormData();
				let bucketPath = null;

				// 1. Upload via socket if media exists
				if (this.questions.questionFile && this.questions.fileMeta) {
					this.showVideoUploading = true;
					bucketPath = await this.uploadFileViaSocket(
						this.questions.questionFile,
						this.questions.fileMeta
					);
				}

				// 2. Append normal fields (UNCHANGED)
				form.append("questionType", this.questions.questionType);
				form.append("difficultyLevel", this.questions.difficultyLevel);
				form.append("question", this.questions.question);
				form.append("marks", this.questions.marks);
				form.append(
					"questionTags",
					JSON.stringify(
						Array.isArray(this.questions.questionTags)
							? this.questions.questionTags.map((t) =>
									t[0] === "#" ? t.slice(1) : t
							  )
							: []
					)
				);
				form.append("addToDatabank", false);
				form.append("addToPublic", false);
				form.append("sectionID", this.selectedSection.sectionID);
				form.append("testID", this.selectedSection.testID);

				// 3. ONLY path goes to backend
				if (bucketPath) {
					form.append("questionMediaPath", bucketPath);
					form.append("questionMediaType", this.questions.questionMediaType);
				} else {
					form.append("delete", 1);
				}

				const res = await addCommunicationTest(form);

				if (res.status === 200) {
					this.successToast("Question added successfully!");
					this.showVideoUploading = false;
					this.showSpinner = false;
					this.progress = 0;
					this.videoData = {};
					this.$emit("question-added");
					this.clearData();
					this.dirtyCommuQuestion = false;
				}
			} catch (err) {
				this.errorToast(err?.message || "Upload failed");
			}
		},
		validateQuestionmcq() {
			if (this.questions.question == "") {
				this.dirtyCommuQuestion = true;
			}
			this.$v.$touch();
		},

		async addautomcqquestion() {
			try {
				this.validateQuestion();

				if (!this.$v.$invalid && !this.dirtyCommuQuestion) {
					const form = this.buildFormData();
					form.append("sectionID", this.autosectionID);
					form.append("testID", this.$route.params.testID);
					form.append("type", "ADD_QUES");
					form.append("topicID", this.topicID);
					form.append("selected", "A");
					form.append("delete", "1");

					const response = await this.postFormData(form);

					if (response.status == 200) {
						this.handleSuccess(response);
						this.clearData();
					} else {
						this.handleError();
					}
				} else {
					this.errorToast("Please enter all the details");
				}
			} catch (error) {
				this.handleError();
				throw new Error(`Failed! status:${error.status}`);
			} finally {
				// clearing card data
				this.clearData();
			}
		},

		validateQuestion() {
			if (this.questions.question === "") {
				this.dirtyCommuQuestion = true;
			}
			this.questions.questionTags = this.questions.questionTags.map((s) =>
				s[0] == "#" ? s.slice(1) : s
			);
			this.$v.$touch();
		},

		buildFormData() {
			const questiontags = JSON.stringify(this.questions.questionTags);
			const form = new FormData();

			for (const key in this.questions) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					this.handleQuestionMedia(form);
				} else {
					form.append(
						key,
						key === "questionTags" ? questiontags : this.questions[key]
					);
				}
			}

			return form;
		},

		handleQuestionMedia(form) {
			if (!this.questions.file && this.questions.questionMedia === "") {
				delete this.questions.file;
				delete this.questions.questionMedia;
				delete this.questions.questionMediaType;
				form.set("delete", 1);
			} else if (!this.questions.file && this.questions.questionMedia !== "") {
				// Do nothing
			} else {
				form.append("questionMedia", this.questions.file);
			}
		},

		async postFormData(form) {
			try {
				return await addCommunicationTest(form);
			} catch (error) {
				console.log(error);
			}
		},

		handleSuccess(response) {
			this.successToast("Question added successfully!");
			this.questions.questionKey = response.data.data.QuestionID;
			this.$emit("question-added");
		},

		handleError() {
			this.errorToast("Something went wrong!");
		},

		removeMedia() {
			this.checkMedia = false;
			this.questions.questionMedia = "";
			this.questions.questionMediaType = null;
			this.questions.questionFile = null;
			this.questions.fileMeta = null;
			this.questions.isFailed = false;
		},
		clearData() {
			this.addques = true;
			this.$refs.questionTagref.reset();
			this.dirtyCommuQuestion = false;
			this.questions.difficultyLevel = "";
			this.$emit("clearData");
			this.showdatacard = false;
			this.$v.$reset();
			this.removeMedia();
		},
	},
};
</script>

<style scoped></style>
